import DexieDB from '../../private/db/db';

const TABLE_NAME = 'ISession';
const TABLE_MAPPINGS = {
    [TABLE_NAME]: 'name, grouping, languageId, tourId, auth',
};

export interface ISessionData {
    name: string;
    userState: string;
    auth: string;
    // grouping: string;
    // languageId: number;
    // tourId: number;
}

const DEFAULT_ISESSIONDATA: ISessionData = {
    name: '',
    userState: '',
    auth: '',
    // grouping: '',
    // languageId: -1,
    // tourId: -1,
    // auth: '',
};

function _instantiate(name: string = TABLE_NAME): DexieDB {
    const db = new DexieDB({
        version: 1,
        mappings: TABLE_MAPPINGS,
        name,
    });

    return db;
}

function load(key: string): Promise<ISessionData> {
    return new Promise(async function (resolve, reject) {
        try {
            const db = _instantiate();

            await db.open();

            const table = db.table(TABLE_NAME);
            const result: ISessionData = await table.get(key);

            db.close();

            if (result) {
                resolve(result);
            } else {
                reject(`Unable to find data named: ${key}`);
            }
        } catch (error) {
            reject(error);
        }
    });
}

function save(name: string, session: ISessionData): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const db = _instantiate();

            await db.open();

            const table = db.table(TABLE_NAME);

            const result = await table.put(session);

            db.close();

            result === session.name
                ? resolve()
                : reject('Failed to save data into patch-storage table');
        } catch (error) {
            reject(error);
        }
    });
}

function remove(name: string): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const db = _instantiate();

            await db.open();

            const table = db.table(TABLE_NAME);

            await table.delete(name);

            db.close();

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

function constructor(data: Partial<ISessionData>): ISessionData {
    return {
        ...DEFAULT_ISESSIONDATA,
        ...data,
    };
}

const module = {
    load,
    save,
    remove,
    constructor,
};

export default module;
